import React, { useState } from "react";
import Tabs from "../../widgets/tabs";
import ClientConnectionModal from "./ClientConnectionModal";

const tabData = [
  { label: "Overview", path: "Overview"},
  { label: "Client Connection", path: "ClientConnection"},
  { label: "Invoicing", path: "Invoicing"},
  { label: "Scheduling", path: "Scheduling"},
  { label: "Quotes", path: "Quotes"},
];

const ClientConnection: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="container-fluid">
      <div className="body-content">
        <Tabs tabs={tabData} activeTabIndex={1} />
        <div className="hero">
            <div className="hero-inner">
            <h1>CLIENT CONNECTION</h1>
            </div>
        </div>
  
        <div className="content-info">
            <p>
            Just a friendly reminder to schedule your weekly meeting with our
            operations team at your earliest convenience by clicking the link
            above.
          </p>
          <div className="client-connection-trigger">
            <button className="green-btn" onClick={() => setIsOpen(true)}>
              WHAT IS A CLIENT CONNECTION MEETING?
            </button>
            <a
              className="green-btn"
              href="https://calendly.com/d/cwvm-rhj-9p9/advanced-mulch-client-connection"
              target="_blank"
              rel="noreferrer"
            >
              SCHEDULE YOUR MEETING
            </a>
          </div>
        </div>
      </div>

      <ClientConnectionModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default ClientConnection;
